// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".room-bg[data-v-c5d187e2]{position:absolute;width:50vh;height:50vh;background-size:100% 100%;background-repeat:no-repeat}.room-bg-top-left[data-v-c5d187e2]{top:20px;left:0}.room-bg-bottom-right[data-v-c5d187e2]{bottom:0;right:0}", ""]);
// Exports
module.exports = exports;
